export const API_BASE_URL =
  process.env.REACT_APP_BACKEND_URL || "http://192.168.31.132:4000/api";
